import { lightFormat } from 'date-fns';

// Thẩm định Email
export function VALIDATE_EMAIL(email) {
	return email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
}

// Loading
export function OPEN_LOADING_DATA_SERVER_API(msg, s) { // modal.style.display = "none";
	document.getElementById('Modal-show-loading-data-api-call') &&
		document.getElementById('Modal-show-loading-data-api-call').classList.add("Modal-show-loading-data-show-modal");
}

export function CLOSE_LOADING_DATA_SERVER_API(msg, s) { // modal.style.display = "none";
	document.getElementById('Modal-show-loading-data-api-call') &&
		document.getElementById('Modal-show-loading-data-api-call').classList.remove("Modal-show-loading-data-show-modal");
}

// Format Date
export function formatDate(value) {
	return value ? lightFormat(new Date(value), 'dd/MM/yyyy') : '';
}

// Giữ nguyên năm trong chuỗi ngày của API, không dịch theo múi giờ.
export function formatYear(value) {
	if (value == null || value === '') return '';
	const year = String(value).match(/^(\d{4})(?:-|$)/);
	if (year) return year[1];
	const date = value instanceof Date ? value : new Date(value);
	return Number.isNaN(date.getTime()) ? '' : lightFormat(date, 'yyyy');
}

export function formatTime(value) {
	return value ? lightFormat(new Date(value), 'HH:mm:ss') : '';
}

export function formatTime1(value) {
	return value ? lightFormat(new Date(value), 'HH:mm') : '';
}

export function formatDatetime(value) {
	return value ? lightFormat(new Date(value), 'dd/MM/yyyy HH:mm') : '';
}

export function formatISODate(value) {
	return value ? lightFormat(new Date(value), "yyyy-MM-dd'T'HH:mm:ss") : null;
}

export function getSizeStr(size) {
	let value = size;
	if (value < 1000) return value + ' bytes';
	value = value / 1000;
	if (value < 1000) return value.toFixed(2) + ' KB';
	value = value / 1000;
	if (value < 1000) return value.toFixed(2) + ' MB';
	value = value / 1000;
	return value.toFixed(2) + ' GB';
}

// Format Currency
export function formatCurrency(value) {
	return new Intl.NumberFormat('vi').format((value !== undefined) ? value : 0);
}

export function dateDiff(date1, date2) {
	const diffTime = Math.abs(date2 - date1);
	const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

	return diffDays;
}

export const dynamicsort = (property, order = 'asc') => {
	var sort_order = 1;
	if (order === "desc") {
		sort_order = -1;
	}
	return (a, b) => {
		// a should come before b in the sorted order
		if (a[property] < b[property]) {
			return -1 * sort_order;
			// a should come after b in the sorted order
		} else if (a[property] > b[property]) {
			return 1 * sort_order;
			// a and b are the same
		} else {
			return 0 * sort_order;
		}
	}
}

const inProps = (key, props) => {
	return props.some((omitKey) => {
		return omitKey === key;
	});
};

export const omit = (obj, props) => {
	let newObj = {};
	Object.keys(obj).forEach((key) => {
		if (!inProps(key, props)) {
			newObj[key] = obj[key];
		}
	});
	return newObj
}

export const strToCurrency = (v, fallback) => {
	if (v === undefined || v === null || v === "") {
		return fallback
	}
	if (isNaN(parseInt(v))) {
		return fallback
	}
	return formatCurrency(v)
}

export function removeVietnameseTones(str) {
	str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
	str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
	str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
	str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
	str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
	str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
	str = str.replace(/đ/g, "d");
	str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
	str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
	str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
	str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
	str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
	str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
	str = str.replace(/Đ/g, "D");
	// Some system encode vietnamese combining accent as individual utf-8 characters
	// Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
	str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
	str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
	// Remove extra spaces
	// Bỏ các khoảng trắng liền nhau
	str = str.replace(/ + /g, " ");
	str = str.trim();
	// Remove punctuations
	// Bỏ dấu câu, kí tự đặc biệt
	str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
	return str;
}

export const parseIntNew = (value) => parseInt(value || 0);
